import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Fab } from '../../fab.model';
import { FabService } from '../../services/fab.service';

@Component({
  selector: 'layout-fab-outlet',
  templateUrl: './fab-outlet.component.html',
  styleUrls: ['./fab-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FabOutletComponent {
    fabs$: Observable<Fab[]> ;
    constructor(private fabService: FabService) {
        this.fabs$ = this.fabService.fabs$;
    }
}
